// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"audio-player_wrapper__3j5dd","isConstructor":"audio-player_isConstructor__D-csO","player":"audio-player_player__3RdDv"};